import * as THREE from "three";

// OpenGL to OpenCV coordinate transformation matrix
// biome-ignore format: ignore
const OPENGL_TO_OPENCV = new THREE.Matrix4().set(
  1, 0, 0, 0,
  0, -1, 0, 0,
  0, 0, -1, 0,
  0, 0, 0, 1,
);

/**
 * Convert THREE.js camera to torchcam format
 */
export function cameraToTorchcam(camera, resolution) {
  camera.updateMatrixWorld();

  // Get camera world matrix in OpenGL convention
  const worldMatrix = camera.matrixWorld.clone();

  // Convert to OpenCV convention
  const cvMatrix = new THREE.Matrix4()
    .multiplyMatrices(OPENGL_TO_OPENCV, worldMatrix)
    .multiply(OPENGL_TO_OPENCV.clone().transpose());

  // Extract intrinsics
  const fov = camera.fov * (Math.PI / 180);
  const fy = resolution.height / (2 * Math.tan(fov / 2));
  const fx = fy * camera.aspect;
  const cx = resolution.width / 2;
  const cy = resolution.height / 2;

  return {
    cameraToWorld: matrixToArray(cvMatrix),
    cameraToPixel: [
      [fx, 0, cx],
      [0, fy, cy],
      [0, 0, 1],
    ],
    imageSizeXY: [resolution.width, resolution.height],
    projectionType: "PERSPECTIVE",
  };
}

/**
 * Convert torchcam camera to THREE.js format
 */
export function torchcamToCamera(cameraData, camera) {
  const cvMatrix = arrayToMatrix(cameraData.cameraToWorld);

  // Convert from OpenCV to OpenGL convention
  const worldMatrix = new THREE.Matrix4()
    .multiplyMatrices(OPENGL_TO_OPENCV.clone().transpose(), cvMatrix)
    .multiply(OPENGL_TO_OPENCV);

  // Apply to camera
  camera.matrix.copy(worldMatrix);
  camera.matrixWorld.copy(worldMatrix);
  camera.position.setFromMatrixPosition(worldMatrix);
  camera.quaternion.setFromRotationMatrix(worldMatrix);

  // Update FOV from intrinsics if provided
  if (cameraData.cameraToPixel && cameraData.imageSizeXY) {
    const fy = cameraData.cameraToPixel[1][1];
    const height = cameraData.imageSizeXY[1];
    const fovRad = 2 * Math.atan(height / (2 * fy));
    camera.fov = fovRad * (180 / Math.PI);
    camera.updateProjectionMatrix();
  }
}

/**
 * Convert THREE.Matrix4 to nested array
 */
export function matrixToArray(matrix) {
  const m = matrix.elements;
  return [
    [m[0], m[4], m[8], m[12]],
    [m[1], m[5], m[9], m[13]],
    [m[2], m[6], m[10], m[14]],
    [m[3], m[7], m[11], m[15]],
  ];
}

/**
 * Convert nested array to THREE.Matrix4
 */
export function arrayToMatrix(array) {
  return new THREE.Matrix4().set(
    array[0][0],
    array[0][1],
    array[0][2],
    array[0][3],
    array[1][0],
    array[1][1],
    array[1][2],
    array[1][3],
    array[2][0],
    array[2][1],
    array[2][2],
    array[2][3],
    array[3][0],
    array[3][1],
    array[3][2],
    array[3][3],
  );
}
